export function getShareLinkRootPath(link, share) {
    const path = link?.regime ? `/app/facilities/${encodeURIComponent(link.regime)}` : "/app/facilities"
    const params = new URLSearchParams()
    if (share) params.set("share", share)
    const query = params.toString()
    if (!query) return path
    return `${path}?${query}`
}
